import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { getSortedArticles } from "@/content/articles";

export const LatestArticles = () => {
  const items = getSortedArticles().slice(0, 3);
  if (items.length === 0) return null;

  return (
    <section id="artiklar-senaste" className="px-6 lg:px-8 py-24 lg:py-32 bg-paper-deep/40">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between gap-6 mb-14 flex-wrap">
          <div className="max-w-2xl">
            <span className="text-xs font-medium tracking-widest uppercase text-oak mb-4 block">
              Kunskapsbank
            </span>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight text-balance">
              Guider för dig som <em className="text-oak not-italic">sköter ekonomin</em>.
            </h2>
          </div>
          <Link
            to="/artiklar"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-ink hover:text-oak transition-colors"
          >
            Alla artiklar
            <ArrowUpRight className="size-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((a) => (
            <Link
              key={a.slug}
              to={`/artiklar/${a.slug}`}
              className="group bg-paper rounded-2xl p-8 ring-1 ring-ink/5 flex flex-col gap-5 hover:ring-oak/40 transition-all"
            >
              <div className="flex items-center gap-3 text-xs text-ink-muted uppercase tracking-wider">
                <time dateTime={a.publishedAt}>
                  {new Date(a.publishedAt).toLocaleDateString("sv-SE", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </time>
                <span aria-hidden>·</span>
                <span>{a.readingMinutes} min</span>
              </div>
              <h3 className="font-display text-2xl leading-tight tracking-tight text-ink text-pretty group-hover:text-oak transition-colors">
                {a.title}
              </h3>
              <p className="text-sm text-ink-muted text-pretty flex-grow">{a.excerpt}</p>
              <span className="text-sm font-medium text-oak inline-flex items-center gap-1">
                Läs artikeln <ArrowUpRight className="size-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};